import { useCallback } from 'react';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { usePlayerTransportController } from '../components/PlayerTransportProvider';
import { usePlayerPause } from './usePlayerPause';
import { usePlayerPlay } from './usePlayerPlay';

export const usePlayerPlayPause = () => {
  const { transportController } = usePlayerTransportController();
  const nativePlaying = usePlayerStore((state) => state.playing);
  const playing = transportController?.playing ?? nativePlaying;
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { onPlayerPlay } = usePlayerPlay();
  const { onPlayerPause } = usePlayerPause();

  const onPlayerPlayPause = useCallback(() => {
    if (transportController) {
      if (transportController.playing) {
        transportController.pause();
      } else {
        transportController.play();
      }

      return;
    }

    if (videoElement) {
      if (videoElement.paused) {
        onPlayerPlay();
      } else {
        onPlayerPause();
      }
    }
  }, [transportController, videoElement, onPlayerPlay, onPlayerPause]);

  return { onPlayerPlayPause, playing };
};
